import { BaseData } from "../../../../../../shared/models/base-data";

export class SellBondConfirmData extends BaseData {
  constructor() {
    super();
  }
}
